/* La app inserta colores inline !important. Se ajusta sólo su presentación,
   conservando eventos de compra, formularios y estados de carga de EasySell. */
(() => {
  if (!document.body.classList.contains('page-type-product')) return;
  const ids = ['es-popup-button', 'es-sticky'];
  const bound = new WeakSet();
  const accessibleClose = new WeakSet();
  const colors = {color:'#202320',background:'#ffd21c','border-color':'#ffd21c','border-radius':'6px','box-shadow':'none'};
  const styled = (node, name, value) => {
    // CSSOM normaliza los colores; comparar contra su forma normal evita bucles.
    const probe = document.createElement('span');
    probe.style.setProperty(name,value,'important');
    if(node.style.getPropertyValue(name)!==probe.style.getPropertyValue(name)||node.style.getPropertyPriority(name)!=='important') node.style.setProperty(name,value,'important');
  };
  function refine(node) {
    for (const [name,value] of Object.entries(colors)) styled(node,name,value);
    node.querySelectorAll('.es-button-title,.es-button-content>div>span').forEach(text=>styled(text,'color','#202320'));
    // El botón de la app es un div con role=button: necesita acceso de teclado.
    if(node.tagName!=='BUTTON'&&node.getAttribute('role')==='button') {
      node.setAttribute('tabindex','0');
      if(!bound.has(node)) node.addEventListener('keydown',event=>{
        if((event.key==='Enter'||event.key===' ')&&!event.repeat&&event.target===node&&!event.defaultPrevented&&node.getAttribute('aria-disabled')!=='true') {event.preventDefault();node.click();}
      });
    }
    if(!bound.has(node)) {
      bound.add(node);
      new MutationObserver(()=>refine(node)).observe(node,{attributes:true,attributeFilter:['style'],childList:true,subtree:true});
    }
  }
  const discover = ()=>{
    ids.forEach(id=>{const node=document.getElementById(id);if(node&&!bound.has(node))refine(node);});
    document.querySelectorAll('#es-form .close-icon').forEach(node=>{
      if(accessibleClose.has(node))return;
      accessibleClose.add(node);
      node.setAttribute('role','button');
      node.setAttribute('aria-label','Cerrar formulario');
      node.setAttribute('tabindex','0');
      node.addEventListener('keydown',event=>{
        if((event.key==='Enter'||event.key===' ')&&!event.repeat&&event.target===node&&!event.defaultPrevented){event.preventDefault();node.click();}
      });
    });
  };
  discover();
  new MutationObserver(discover).observe(document.body,{childList:true,subtree:true});
})();
